import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import RazorpayCheckout from "./razorpayCheckout";
import StripeCheckout from "./stripePayment";

const BookingCheckout = () => {
  const reduxLocation = useSelector((state) => state.globalState?.student_details?.data?.location);
  const routerLocation = useLocation();
  const isIndia = reduxLocation?.includes("India");

  const {
    purchaseType = "meet_session",
    bookingData = null,
    teacherOptions = null,
    orderId = null,
    amount = null
  } = routerLocation.state || {};

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12 col-md-12">
          {/* Route to Razorpay for India, Stripe for rest of world */}
          {isIndia ? (
            <RazorpayCheckout
              purchaseType={purchaseType}
              bookingData={bookingData}
              teacherOptions={teacherOptions}
              orderId={orderId}
              amount={amount}
            />
          ) : (
            <StripeCheckout
              purchaseType={purchaseType}
              bookingData={bookingData}
              teacherOptions={teacherOptions}
              orderId={orderId}
              amount={amount}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingCheckout;
